export const GenerateDisplayId = (prefix, id) => {
  return (
    prefix +
    (id
      ? id.toLocaleString("en-US", {
          minimumIntegerDigits: 6,
          useGrouping: false,
        })
      : "")
  );
};
